import React, { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { startMockApplication } from './mock/store';

const StartApplicationPortal: React.FC = () => {
  const navigate = useNavigate();
  const [submitted, setSubmitted] = useState(false);

  const handleBegin = () => {
    startMockApplication();
    setSubmitted(true);
  };

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Start application
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        Begin an Educational Loan Fund application. This preview does not submit
        a real application.
      </Typography>

      <Paper variant="outlined" sx={{ p: 3 }}>
        {submitted ? (
          <>
            <Typography variant="h6" gutterBottom>
              Application recorded (preview)
            </Typography>
            <Typography sx={{ mb: 3 }}>
              Your sample application is now marked as pending review. In the
              live system, this would continue into the full application form.
            </Typography>
            <Button
              component={RouterLink}
              to="/portal/applications"
              variant="contained"
            >
              Back to applications
            </Button>
          </>
        ) : (
          <>
            <Typography variant="h6" gutterBottom>
              Before you begin
            </Typography>
            <Typography paragraph>
              You will be asked for personal information, education plans, and
              chapter sponsorship details. Plan about 20–30 minutes to complete
              the full application when it is available.
            </Typography>
            <Typography paragraph color="text.secondary">
              For this preview, selecting Begin will mark a sample application
              as pending so you can see the status home screen.
            </Typography>
            <Stack direction="row" spacing={2}>
              <Button variant="contained" onClick={handleBegin}>
                Begin application
              </Button>
              <Button onClick={() => navigate('/portal/applications')}>
                Cancel
              </Button>
            </Stack>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default StartApplicationPortal;
